import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx } from '@emotion/react';
import { cleanCommonProps, getStyleProps } from '../utils';
export const groupCSS = ({
  theme: {
    spacing
  }
}, unstyled) => unstyled ? {} : {
  paddingBottom: spacing.baseUnit * 2,
  paddingTop: spacing.baseUnit * 2
};
const Group = props => {
  const {
    children,
    cx,
    getStyles,
    getClassNames,
    Heading,
    headingProps,
    innerProps,
    label,
    theme,
    selectProps
  } = props;
  return jsx("div", _extends({}, getStyleProps(props, 'group', {
    group: true
  }), innerProps), jsx(Heading, _extends({}, headingProps, {
    selectProps: selectProps
    // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
    ,
    theme: theme,
    getStyles: getStyles,
    getClassNames: getClassNames,
    cx: cx
  }), label), jsx("div", null, children));
};
export const groupHeadingCSS = ({
  theme: {
    colors,
    spacing
  }
}, unstyled) => ({
  label: 'group',
  cursor: 'default',
  display: 'block',
  ...(unstyled ? {} : {
    color: colors.neutral40,
    fontSize: '75%',
    fontWeight: 500,
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  })
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const GroupHeading = props => {
  const {
    data,
    ...innerProps
  } = cleanCommonProps(props);
  return jsx("div", _extends({}, getStyleProps(props, 'groupHeading', {
    'group-heading': true
  }), innerProps));
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Group;